const getCustomHtmlProperties = ({ customHtmlProps = [] }) =>
  customHtmlProps
    ? customHtmlProps.reduce((acc, { name, value }) => {
        if (name) {
          acc[name] = value !== 'null' ? value : undefined;
        }
        return acc;
      }, {})
    : {};

export default getCustomHtmlProperties;
